//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue              from 'vue';
import Component        from 'vue-class-component';
import Bugsnag          from '@bugsnag/js'
import EState           from '@/classes/State.enum';
import MarkdownRenderer from '@/components/MarkdownRenderer';
import LoaderLarge      from '@/components/LoaderLarge';
import MissingNo        from '@/components/MissingNo';

@Component({
	components : {
		MarkdownRenderer,
		LoaderLarge,
		MissingNo,
	},
	props      : {
		filename : String,
		standard : String,
		// title    : String,
	},
})
export default class Changelog extends Vue {
	// Constants passthrough
	//--------------------------------------------------------------------------------------------------

	EState = EState;

	// Members
	//--------------------------------------------------------------------------------------------------

	state    = EState.NONE;
	contents = null;

	// Lifecycle
	//--------------------------------------------------------------------------------------------------

	/**
	 * TODO
	**/
	mounted () {
		this.state = EState.LOADING;

		this.loadFile(this.filename)
			.then(contents => {
				this.contents  = contents;
				this.metaTitle = this.title;
				this.state     = EState.LOADED;
			})
			.catch(err => {
				this.state = EState.ERROR;
				
				Bugsnag.notify(err);
			});
	}

	// Methods
	//--------------------------------------------------------------------------------------------------

	/**
	 * TODO: Should be moved into global helper script
	**/
	loadFile (filename, callback) {
		return new Promise(function (resolve, reject) {
			const request = new XMLHttpRequest();

			request.onreadystatechange = function () {
				if (request.readyState === 4) {
					if (request.status === 200 || request.status === 0) {
						if (!!callback) {
							resolve(callback(request.responseText));
						} else {
							resolve(request.responseText);
						}
					} else {
						reject();
					}
				}
			}
			request.overrideMimeType('text/plain');
			request.open('GET', filename, true);
			request.send();
		});
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<transition name="t--fade" mode="out-in">
	<!--#############################################################################################-->
	<div
		v-if  = "state === EState.LOADING"
		key   = "loader"
		class = "g--center-content"
	>
		<LoaderLarge />
	</div>

	<!--#############################################################################################-->
	<MissingNo v-if="state === EState.ERROR" key="error">
		<slot />
	</MissingNo>

	<!--#############################################################################################-->
	<MarkdownRenderer
		v-if      = "state === EState.LOADED"
		key       = "contents"
		:contents = "contents"
		:standard = "standard"
	/>
</transition>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
</style>
